import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import Tools from '../tools/tools';

const ModalUpload = (props) => {
    var [title, setTitle] = useState("");
    var [remark, setRemark] = useState("");

    const sendFile = () => {
        console.log("title", title);
        if ((title || "") === "") {
            toast.error("Моля, въведете Заглавие");
            return;
        }
        var formData = new FormData();
        var div = document.querySelector('#dFileUpload');
        var imagefile = div.querySelector('#fuFile');
        if (imagefile.files.length===0) {
            toast.error("Моля, изберете файл");
            return;
        }
        formData.append("file", imagefile.files[0]);
        formData.append("title", title);
        formData.append("remark", remark);

        Comm.InstanceForImage().post('Document', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(result => {
            
            props.closeFunc(result.data);
        }).catch(error => Tools.ProcessError(error));

    }

    return (
        <Dialog header="Електронен оригинал" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc(null)}>
            <div id="dFileUpload">
                <p>
                    <label>Заглавие</label><input className="form-control" type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                </p>
                <p>
                    <label>Описание</label><textarea className="form-control" rows="6" value={remark} onChange={(e) => setRemark(e.target.value)} />
                </p>
                <p>
                    <label>Файл</label><input className="form-control" type="file" id="fuFile" />
                </p>
                <button className="btn btn-primary" onClick={() => sendFile()}>Запис</button>
            </div>
        </Dialog>

    );
}


export default ModalUpload;

